<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />
    <ul class="menu-container">
      <template v-for="(item,index) in currentRoutes">
        <li
          v-if="!item.hidden"
          :key="index"
          :class="{active:activeMenu==item.path}"
        >
          <div
            class="cup"
            @click="jump(item.path)"
          >{{ item.meta.title || '暂无标题' }}</div>
        </li>
      </template>
    </ul>

    <!-- <div class="right-menu flexCenter">
      <template v-if="device!=='mobile'">
        <div class="flexCenter">
          <span class="userName">{{ name ||'你的名字' }}</span>
        </div>
      </template>
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <img v-if="avatar" :src="avatar" class="user-avatar">
          <img v-else src="@/assets/images/avatar.png" class="user-avatar">
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <a :href="baseUrl+'profile/updatePassword'">
            <el-dropdown-item>修改密码</el-dropdown-item>
          </a>
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div> -->

    <div class="right-menu flexCenter margin-r-20">
      <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          {{ name ||'你的名字' }}<i class="el-icon-arrow-down el-icon--right" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <a :href="baseUrl+'profile/updatePassword'">
            <el-dropdown-item>修改密码</el-dropdown-item>
          </a>
          <el-dropdown-item @click.native="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { messageUnRead } from '@/api/common.js'
import Hamburger from '@/components/Hamburger'
import { isExternal } from '@/utils/validate'
import store from '@/store'
export default {
  components: {
    Hamburger
  },
  data() {
    return {
      NODE_ENV: '',
      baseUrl: process.env.VUE_APP_ROUTER_URL,
      timer: null,
      data: {
        readCount: 0,
        unReadCount: 0
      }
    }
  },
  computed: {
    ...mapGetters([
      'name',
      'permission_routes',
      'sidebar',
      'avatar',
      'device',
      'userModule'
    ]),
    currentRoutes() {
      return this.permission_routes
    },
    activeMenu() {
      const route = this.$route
      const path = route.matched[0].path
      return path == '' ? '/' : path
    }
  },
  created() {
    this.NODE_ENV = process.env.NODE_ENV
    // this.getList()
  },
  beforeDestroy() {},
  methods: {
    // 链接跳转
    jump(url) {
      if (isExternal(url)) {
        location.href = url
      } else {
        this.$router.push(url)
      }
    },

    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.margin-r-20 {
  margin-right: 20px;
}
.margin-r-30 {
  margin-right: 30px;
}
.margin-r-50 {
  margin-right: 50px;
}

.el-dropdown-link {
  cursor: pointer;
}
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  .userName {
    float: left;
    font-size: 14px;
  }
  .menu-container {
    list-style: none;
    margin: 0;
    height: 50px;
    float: left;
    > li {
      float: left;
      /*width: 180px;*/
      padding: 0 20px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 18px;
      &.active {
        color: #fff;
        background: #2b6fef;
      }
      @media (max-width: 500px) {
        width: auto;
        padding: 0 10px;
        font-size: 20px;
      }
    }
    &:after {
      content: "";
      display: block;
      clear: both;
    }
  }
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;
    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }
  .breadcrumb-container {
    float: left;
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    &:focus {
      outline: none;
    }
    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;
      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;
        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }
    .avatar-container {
      margin-right: 30px;
      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
